import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { SmtpConfigComponent } from './smtp-config.component';

const routes: Routes = [{ path: '', component: SmtpConfigComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SmtpConfigRoutingModule { }
